<template>
  <div class="flex flex-row h-full w-full">
    <div class="w-full h-full" id="google-maps"></div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'

const API_KEY = 'AIzaSyAlDrciAoup0vODRe_A0zhKDyiEmEr-nwI'

const options = {
  version: 'weekly',
  apiKey: API_KEY
}

export default {
  name: 'TrafficLocationsMap',

  async mounted() {
    const loader = new Loader(options)
    const { Map } = await loader.importLibrary('maps')

    const map = new Map(document.getElementById('google-maps'), {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 8,
      gestureHandling: 'greedy',
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
      zoomControl: true,
      mapTypeId: 'roadmap'
    })
    console.log(map)
  }
}
</script>
